import { /* useNavigate, */ useParams } from "react-router-dom";
import SaveTrasladoInventario from "../../shared/componente/save_traslado/SaveTrasladoInventario";
import { useGetSolicitudPedido, useUpdateSolicitudesEgresos } from "@/shared/actions/erp";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useEffect, useMemo } from "react";
import { EstadosSolicitudPeodidoEnum, MaterialTransferido } from "@/shared/interfaces";
//import { number } from "card-validator";


export default function TransferenciaInventarioPedidoPage() {
    const { id_solicitudegreso } = useParams()
    //const navigate = useNavigate()
    //store
    const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
    const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)

    //fetch solictud
    const { data: dataSolicitudPedido } = id_solicitudegreso
        ? useGetSolicitudPedido(id_solicitudegreso!)
        : { data: null }
    console.log('solictud_trasferencia', dataSolicitudPedido)
    const updateSolicitudesPedidos = useUpdateSolicitudesEgresos({ enableSuccessAlert: false })
    ////
    const bodegaOrigen = dataSolicitudPedido?.data?.bodega;
    const ubicacionOrigen = dataSolicitudPedido?.data?.ubicacion_data?.codigo;
    const codigoSolicitud = dataSolicitudPedido?.data?.codigo;
    const defaultValues = useMemo(() => ({
    bodega_origen: bodegaOrigen,
    ubicacion_origen: ubicacionOrigen,
    solicitud_egreso: codigoSolicitud,
    }), [bodegaOrigen, ubicacionOrigen, codigoSolicitud]);

    // Cargar solo productos con stock (Listo para transferir)
    const cargarProductos = useMemo(() => {
        if (!dataSolicitudPedido?.data.productos) return [];

        return (dataSolicitudPedido.data.productos as any[])
            .filter((item:any)=>{
                const stock = Number(item.producto_data?.stock_actual ?? 0)
                return stock > 0 && Number(item.cantidad_pendiente) > 0;
            })
            .map((item: any) => {
                const stock = Number(item.producto_data?.stock_actual ?? 0);
                const pendiente = Number(item.cantidad_pendiente ?? 0);

                return {
                    ...item,
                    cantidad: Math.min(stock, pendiente),
                    //Nuevo
                    ubicacion_origen: dataSolicitudPedido.data.ubicacion_data?.codigo,
                    solicitud_egreso: dataSolicitudPedido.data.codigo,
                } as MaterialTransferido;
            });
    }, [dataSolicitudPedido]);

    useEffect(() => {
        if (!cargarProductos?.length) return
        handleCopiarLista(cargarProductos)
    }, [cargarProductos])
    // despues de trasferir, decidir sin finalizar o no
    const handleAfterTransfer = async () => {
        const hayPendientes = dataSolicitudPedido?.data.productos
            ?.some(p => Number(p.cantidad_pendiente) > 0)

        if (!hayPendientes) {
            await updateSolicitudesPedidos.mutateAsync({
                id: id_solicitudegreso,
                data: {
                    estado_solicitud: EstadosSolicitudPeodidoEnum.FINALIZADO
                }
            } as any)
        }
        // si hay pendientes, nose finalzia(queda aprobadas)
    }
    useEffect(() => {
        return () => clearSelectedItems()
    }, [])

    return (
         <SaveTrasladoInventario
            title="📦Transferencia de Pedido"
            defaultValues={defaultValues}
            onSuccess={handleAfterTransfer}
            esTransferenciaPedido                                   // 👈 enciende el flujo
            codigoSolicitud={dataSolicitudPedido?.data?.codigo}     // 👈 para el asunto del correo
        />
    )
}